import { useState } from "react";
import { motion } from 'framer-motion';
import ModelButton from "../../modelBtn/modelButton";
import { PropTypes } from 'prop-types';
import { FaArrowRight } from "react-icons/fa6";

const Apply = ({ text, children }) => {
    const [modalOpen, setModalOpen] = useState(false);

    const closed = () => setModalOpen(false);
    const open = () => setModalOpen(true);
    return (
        <>

            <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.9 }}
                className="px-8 py-4 bg-red-800 rounded justify-center items-center gap-4 flex w-fit"
                onClick={() => (modalOpen ? closed() : open())}
            >
                <span className="text-white text-base font-bold capitalize flex items-center gap-3">{text} <FaArrowRight /></span>
            </motion.button>


            <ModelButton modalOpen={modalOpen} close={closed}>
                {children}
            </ModelButton>
        </>
    )
}
Apply.propTypes = {
    text: PropTypes.string,
    children: PropTypes.node
}
export default Apply